<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting(v-if="parameters.mode")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer')[parameters.mode] }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
            span(slot="value")
                | {{ parameters.combining ? $i18n.t('common')[parameters.difficult] + ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : $i18n.t('common')[parameters.difficult] }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}
            span(slot="value") {{ parameters.amountOfActions }}
        game-preview-setting(v-if="parameters.amountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting(v-else-if="parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        game-preview-setting(v-if="parameters.speed")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
            span(slot="value") {{ parameters.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="parameters.isSpeedIncrease")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_acceleration') }}
            span(slot="value")
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_For') }}
                | {{ parameters.speedUp }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }} {{ amountOfSpeedExercises }}
        game-preview-setting(v-if="parameters.isComplication")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}
            span(slot="value")
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_For') }}
                | {{ amountOfActions }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }} {{ amountOfComplicationExercises }}
        game-preview-setting(v-if="type !== 'AdditionAndSubtractionMathMagic'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_simple') }}
            span(slot="value") {{ rulesArrayToString(parameters.simple) }}
        game-preview-setting(v-if="parameters.brothers && parameters.brothers.length > 0")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_brothers') }}
            span(slot="value") {{ rulesArrayToString(parameters.brothers) }}
        game-preview-setting(v-if="parameters.friends && parameters.friends.length > 0")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_friends') }}
            span(slot="value") {{ rulesArrayToString(parameters.friends) }}
        game-preview-setting(v-if="parameters.brothersAndFriends && parameters.brothersAndFriends.length > 0")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_brothersAndFriends') }}
            span(slot="value") {{ rulesArrayToString(parameters.brothersAndFriends) }}
        game-preview-setting(v-if="parameters.jumpOver")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_transitionThrough') }}
            span(slot="value") {{ parameters.jumpOver.value }}
        game-preview-setting(v-if="type !== 'AdditionAndSubtractionMathMagic'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_answers') }}
            span(slot="value") {{ answers }}
        template(v-if="parameters.dictation")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                span(slot="value")
                    | {{ parameters.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        template(v-if="parameters.fractions")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                span(slot="value") {{ parameters.fractionalPart }}
        game-preview-setting(v-if="parameters.mirror")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting(v-if="parameters.roundNumbers")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting(v-if="parameters.showExampleInTheLine")
            span(slot="name") {{ $i18n.t('trainer.trainer_gamePreview_exampleInTheLine') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        template(v-if="parameters.extraOptions")
            game-preview-setting(v-if="parameters.extraOptions.music")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.pictures")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_pictures') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.x2")
                span(slot="name") X2
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.motion")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_numbers')}) }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.voiceOver === undefined || parameters.extraOptions.voiceOver")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_voiceActing') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer'
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [TrainerUtilities],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            amountOfComplicationExercises () {
                return this.parameters.tasksForComplication + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.parameters.tasksForComplication);
            },
            amountOfSpeedExercises () {
                return this.parameters.tasksForSpeedUp + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.parameters.tasksForSpeedUp);
            },
            amountOfActions () {
                return this.parameters.complication + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_actionDeclination', this.parameters.complication);
            },
            timeLimit () {
                return this.parameters.timeLimit + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit);
            },
            answers () {
                if (this.parameters.positiveAnswers && this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAny');
                }
                if (this.parameters.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositive');
                }
                if (this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegative');
                }
            },
        }
    }
</script>
